import { v4 as uuidv4 } from "uuid";
const toast = {
  namespaced: true,
  state: {
    toasts: [],
  },
  mutations: {
    add(state, payload) {
      payload.key = `${payload.title}_${uuidv4}_${Date.now()}`;
      state.toasts.push(payload);
    },
    clear(state, payload) {
      if (payload) {
        const index = state.toasts.findIndex((toast) => toast.key === payload);
        state.toasts.splice(index, 1);
      } else {
        state.toasts = [];
      }
    },
  },
};

export default toast;
